// require("./lib/social");
// require("./lib/ads");
// var track = require("./lib/tracking");

require("component-responsive-frame/child");
require("component-leaflet-map");

var $ = require("./lib/qsa");

var mapElement = $.one(".devos-map");
var { map, leaflet } = mapElement;

var visits = leaflet.featureGroup();

var onClick = function(e) {
  var d = this.data;
  var html = `
<h2>${d.city}</h2>
<ul>
${d.visits.map(v => `
  <li class="visit">
    <h3>${v.date}</h3>
    <div>${v.visited ? `<b>Visited:</b> ${v.visited}` : ""}</div>
    <div><b>Reason for visit:</b> ${v.reason}</div>
    <div>${v.protests ? `<b>Protests:</b> ${v.protests}` : ""}</div>
    <div class="read-more"><a href="${v.link}" target="_blank">Read more &raquo;</a>
`).join("\n")}
  `;
  map.openPopup(html, this.getLatLng(), { maxHeight: 240, className: "visit-popup" });
};

var cities = {};

window.visitData.forEach(function(v) {
  if (!cities[v.address]) {
    cities[v.address] = {
      visits: [],
      lat: v.lat,
      lng: v.lng,
      city: v.address
    };
  }
  var [month, day] = v.sort.split("/");
  v.d = new Date(2017, month - 1, day);
  cities[v.address].visits.push(v);
});

window.visitData.sort((a, b) => a.d - b.d);

var timeline = $.one(".timeline");
timeline.innerHTML = visitData.map((v, i) => `<div class="dot" data-index=${i}></div>`).join("");

timeline.addEventListener("click", function(e) {
  var index = e.target.getAttribute("data-index");
  var visit = visitData[index];
  if (!visit) return;
  var city = cities[visit.address];
  var marker = city.marker;
  // map.setView(marker.getLatLng());
  marker.fire("click");
})

for (var c in cities) {
  var city = cities[c];
  var marker = leaflet.marker([city.lat, city.lng], {
    icon: leaflet.divIcon({
      className: "visit-marker",
      iconSize: [16, 16]
    })
  });
  city.marker = marker;
  marker.addTo(visits);
  marker.data = city;
  marker.on("click", onClick);
}

visits.addTo(map);
map.fitBounds(visits.getBounds());